import { SnackbarAction } from "notistack";
import { extractWorkViewLink } from "../../components/entitiesReferences/InternalEntityLink";
import { workService } from "../../services/workService";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { Work, WorkFilters } from "../../types/work";
import { useEntityQueryClient } from "./entityQueryClient";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useWorkLogic from "../logic/workLogic";

const useWorkQuery = (systemLanguageType: Work["system_language_type"]) => {
  const navigate = useNavigate();
  const { getDisplayName, defaultWork } = useWorkLogic(systemLanguageType);
  return useEntityQueryClient<Work, WorkFilters>({
    service: workService,
    collection: SystemEntityCollections.WORK,
    defaultEntity: defaultWork,
    snackbarDisplayName: getDisplayName,
    snackbarAction: (data: Work): SnackbarAction => (
      <Button
        variant="text"
        onClick={() => navigate(extractWorkViewLink(data))}
        sx={{ color: "white" }}
      >
        View Work
      </Button>
    ),
  });
};

export default useWorkQuery;
